<script>
  import { countryStore } from "../store/Countries.js";
  import { fade } from "svelte/transition";
  import { getContext } from "svelte";
  import Table from "../SharedComponents/Table.svelte";
  import Plus from "../Vectors/Plus.svelte";
  import * as util from "../js/util.js";
  import { link, navigate } from "svelte-routing";
  import AddCountry from "./AddCountry.svelte";

  const { open } = getContext("modal");

  let userId = "";

  function AddCountryAction() {
    open(AddCountry, null);
  }

  function EditCountry(country) {
    navigate("/app/countries/" + country.id);
  }

  async function deleteCountry(country) {
    if (!confirm("are you sure")) return;
    var result = await countryStore.deleteCountry(country);
    if (!result.success) {
      snackbar("error", result.message);
    }
    await countryStore.getCountries();
  }

  countryStore.getCountries();
  $: useCountries =
    $countryStore.countries &&
    $countryStore.countries.map((u) => {
      return {
        id: u.id,
        columns: { NameKey: u.nameKey },
      };
    });


</script>

<Table
  Title="Countries"
  bind:Items={useCountries}
  AddRowCallBack={AddCountryAction}
  RowClickCallBack={EditCountry}
  CustomActionCallBack={deleteCountry}
  CustomActionName="Delete"
/>
